import EcsContact from './EcsContact';

// Include agents, supervisors, channels and BPs
export default class EcsInternalBusinessContact extends EcsContact {
  get isInternalContact() {
    return true;
  }

  get phones() {
    if (!this.endPoint) {
      return [];
    }

    return [
      {
        description: 'EndPoint',
        value: this.endPoint
      }
    ];
  }

  get isChatEnabled() {
    return true;
  }

  /**
   * Compares two given EcsInternalBusinessContact objects for order.
   * Returns a negative integer, zero, or a positive integer as ContactA object is less than,
   * equal to, or greater than ContactB object.
   *
   * @param {EcsInternalBusinessContact} contactA
   * @param {EcsInternalBusinessContact} contactB
   *
   * @returns {Number}
   */
  static compare(contactA, contactB) {
    const comparableFieldsA = (contactA.name || '').toUpperCase();
    const comparableFieldsB = (contactB.name || '').toUpperCase();

    if (comparableFieldsA < comparableFieldsB) {
      return -1;
    }
    if (comparableFieldsA > comparableFieldsB) {
      return 1;
    }
    return 0;
  }
}
